module.exports = __webpack_public_path__ + "static/antd-cascader-ed24fa6fcae78adbdc79c9dd2c0cbb72.png";